import React from 'react';
import ParticipantItem from './ParticipantItem'; // Import der einzelnen Item-Komponente

const ParticipantList = ({
    participants,
    editingParticipantId,
    verifyingParticipantId,
    onEditRequest,
    onStartVerification,
    onCancelVerification,
    onConfirmVerification,
    onSaveEdit,
    onCancelEdit,
    onDeleteParticipant,
    globalLoading
}) => {
    if (!participants || participants.length === 0) {
        return <div className='rakete-font fs-7 text-secondary text-center py-3'>Noch keine Teilnehmer*innen. Sei der/die Erste!</div>;
    }

    const sortedParticipants = [...participants].sort((a, b) =>
        (b.createdAt && a.createdAt) ? new Date(b.createdAt) - new Date(a.createdAt) : 0
    );

    return (
        <div className="mt-2">
            {sortedParticipants.map((participant, index) => (
                <ParticipantItem
                    key={participant._id}
                    participant={participant}
                    isEditingThis={editingParticipantId === participant._id}
                    isVerifyingThis={verifyingParticipantId === participant._id}
                    onEditRequest={onEditRequest}
                    onStartVerification={onStartVerification}
                    onCancelVerification={onCancelVerification}
                    onConfirmVerification={onConfirmVerification}
                    onSaveEdit={onSaveEdit}
                    onCancelEdit={onCancelEdit}
                    onDeleteParticipant={onDeleteParticipant}
                    globalLoading={globalLoading || (editingParticipantId && editingParticipantId !== participant._id) || (verifyingParticipantId && verifyingParticipantId !== participant._id)}
                    isLast={index === sortedParticipants.length - 1}
                />
            ))}
        </div>
    );
};

export default ParticipantList;